import React, { useState } from 'react';
import UserSuspendedModal from 'containers/UserSuspendedModal';
import { isOnApaKeyForUserSuspended } from 'utils/isOnApaKeyForUserSuspended';

const UserSuspendedProvider = ({ children }) => {
  const [isOnUserSuspended, setIsOnUserSuspended] = useState(
    isOnApaKeyForUserSuspended(),
  );
  const renderUserSuspendedModal = () =>
    isOnUserSuspended && <UserSuspendedModal />;
  return (
    <>
      {renderUserSuspendedModal()}
      {children}
    </>
  );
};

export default UserSuspendedProvider;
